import React from "react";
import {Input, Result, Space, Upload} from "antd";
import {CloseCircleOutlined, CloseOutlined, DeleteFilled, EditFilled, PaperClipOutlined} from "@ant-design/icons";
import {t} from "i18next";
import swal from "sweetalert";
import moment from "moment";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import {
    ArrowLeftOutlined,
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Form,
    InputDate,
    InputText,
    NumberInput,
    PlusOutlined,
    Row,
    Select,
    SelectInput,
    Spin,
    Steps,
    Table,
    Tag
} from "common/elements";
import {
    getEmployeeBenefits,
    getEmployeeCertificates,
    getFormPayload,
    getOne,
    resetPassword,
    updateRecordById
} from "services/employee";
import {getAllowances} from "services/payroll_item";
import {Util} from "common/util";
import {getHostURl, getURl} from "services/core";
import Enum from "common/enums";
import {getMany} from "services/project";


const {Dragger} = Upload;

class UpdateForm extends React.PureComponent {
    state = {
        loading: false,
        loadingButton: false,
        id: null,
        formData: {
            gender: 0,
        },
        errorFields: [],
        requiredContractChangedAt: false,
        requiredContractEndDate: false,
        requiredLastWorkingDay: false,
        requiredNoticePeriodType: false,
        projects: [],
        roles: [],
        departments: [],
        dutyStations: [],
        fifthLineManagers: [],
        fourthLineManagers: [],
        thirdLineManagers: [],
        supervisors: [],
        teams: [],
        employeeBenefits: [],
        passportTypes: [],
        visaTypes: [],
        nationalities: [],
        kids: [],
        inheritances: [],
        siblings: [],
        educations: [],
        certifications: [],
        languages: [],
        skills: [],
        payrollItems: [],
        certificateList: [],
        benefitFiles: [],
        secondLineManagers: [],
        jobGrades: [],
        jobLavels: [],
        budgetAllocations: [],
        fileList: [],
        currentStep: 0,
    };

    util = new Util();
    gender = 0;
    updateKidData = [];
    updateSiblingData = [];
    updateInheritanceData = [];
    updateEducationData = [];
    updateCertificationData = [];
    updateBudgetAllocationData = [];
    updateLanguageData = [];
    updateSkillData = [];
    fixedEmployeeBenefits = [];
    employeeBenefitDelete = [];

    componentDidMount() {
        if (Util.getInstance().hasPermission("edit", "employee")) {
            const id = this.props.id;
            getEmployeeCertificates(id).then((response) => {
                const data = response.data;
                if (data) {
                    const newData = data.map((value, index) => ({
                        uid: -Math.abs(index + 1),
                        name: value,
                        status: 'done',
                        url: `${getHostURl()}/public/uploads/${Util.getInstance().getClientId()}/certificates/${id}/${value}`,
                    }));

                    this.setState({
                        certificateList: newData
                    })
                }
            });

            getMany({limit: 0}).then((response) => {
                if (response && response.data) {
                    this.setState({
                        projects: response.data.map(value => ({
                            id: value.id,
                            name: value.title,
                            code: value.code,
                            payload: value.payload ? value.payload : []
                        }))
                    });
                }

            });

            getEmployeeBenefits(id).then((response) => {
                const data = response.data;

                if (data) {
                    const newData = data.map((value, index) => ({
                        uid: -Math.abs(index + 1),
                        name: value,
                        status: 'done',
                        url: `${getHostURl()}/public/uploads/${Util.getInstance().getClientId()}/benefits/${id}/${value}`,
                    }));

                    this.setState({
                        benefitFiles: newData
                    })
                }
            });

            getFormPayload()
                .then((response) => {
                    if (response && response.data) {
                        const data = response.data;
                        this.setState({
                            roles: data.roles,
                            departments: data.departments,
                            dutyStations: data.dutyStations,
                            fifthLineManagers: data.fifthLineManagers,
                            fourthLineManagers: data.fourthLineManagers,
                            thirdLineManagers: data.thirdLineManagers,
                            supervisors: data.supervisors,
                            teams: data.teams,
                            passportTypes: data.passportTypes,
                            visaTypes: data.visaTypes,
                            nationalities: data.nationalities,
                            secondLineManagers: data.secondLineManagers,
                            jobGrades: data.jobGrades,
                            jobLavels: data.jobLavels,
                        });
                    }
                });

            getAllowances().then((response) => {
                if (response.data) {
                    this.setState({
                        payrollItems: response.data.map((value) => ({
                            payrollItemId: value.id,
                            code: value.code,
                            name: value.title,
                            type: value.type,
                            taxRate: value.taxRate
                        })),
                    });
                }
            });

            this.setState({loading: true});
            getOne(id)
                .then((response) => {
                    if (response) {
                        const data = response.data;
                        let seniority_severancePay = null;
                        this.onChangeNoticePeriodType(data.noticePeriodType);
                        this.onChangeContractType(data.contractType);
                        this.onChangeStatus(data.status);
                        this.onChangeNoticeTerminate(data.isNoticeTerminate);
                        this.fixedEmployeeBenefits = [
                            {
                                ...data.phoneAllowance, fix: true
                            },
                            {
                                ...data.housingAllowance, fix: true
                            },
                            {
                                ...data.gasolineAllowance, fix: true
                            },
                        ]

                        if (data.seniority) seniority_severancePay = "SENIORITY"
                        if (data.severancePay) seniority_severancePay = "SEVERANCEPAY"

                        this.props.form.setFieldsValue({
                            code: data.code,
                            firstName: data.firstName,
                            lastName: data.lastName,
                            firstNameKH: data.firstNameKH,
                            lastNameKH: data.lastNameKH,
                            gender: data.gender,
                            headOfDepartmentId: data.headOfDepartmentId,
                            contractEndDate: data.contractEndDate ? moment(data.contractEndDate) : null,
                            contractType: data.contractType,
                            contractChangedAt: data.contractChangedAt ? moment(data.contractChangedAt) : null,
                            approver1Id: data.approver1Id,
                            approver2Id: data.approver2Id,
                            actingById: data.actingById,
                            actingStart: data.actingStart ? moment(data.actingStart) : null,
                            actingEnd: data.actingEnd ? moment(data.actingEnd) : null,
                            fifthLineManagerId: data.fifthLineManagerId,
                            fourthLineManagerId: data.fourthLineManagerId,
                            supervisorId: data.supervisorId,
                            departmentId: data.departmentId && parseInt(data.departmentId),
                            position: data.position,
                            lastWorkingDay: data.lastWorkingDay ? moment(data.lastWorkingDay) : null,
                            teamId: data.teamId && parseInt(data.teamId),
                            roleId: data.user?.roleId,
                            payrollCurrency: data.payrollCurrency,
                            basicSalary: data.basicSalary,
                            lastModifiedSalaryAt: data.lastModifiedSalaryAt ? moment(data.lastModifiedSalaryAt) : null,
                            joinDate: data.joinDate && moment(data.joinDate),
                            probationExpiredDate: data.probationExpiredDate && moment(data.probationExpiredDate),
                            status: data.status,
                            address: data.address,
                            maritalStatus: data.maritalStatus,
                            dob: data.dob ? moment(data.dob) : null,
                            placeOfBirth: data.placeOfBirth,
                            nationalityId: data.nationalityId ? parseInt(data.nationalityId) : null,
                            religious: data.religious,
                            ethnicity: data.ethnicity,
                            nationIDNumber: data.nationIDNumber,
                            expiredDate: data.expiredDate ? moment(data.expiredDate) : null,
                            bankAccNumber: data.bankAccNumber,
                            notifyEmail: data.notifyEmail,
                            userName: data.user?.userName,
                            passportTypeId: data.passportTypeId,
                            passportNumber: data.passportNumber,
                            passportIssuedDate: data.passportIssuedDate ? moment(data.passportIssuedDate) : null,
                            passportIssuedPlace: data.passportIssuedPlace,
                            passportExpiredDate: data.passportExpiredDate ? moment(data.passportExpiredDate) : null,
                            visaTypeId: data.visaTypeId,
                            visaNumber: data.visaNumber,
                            visaExpiredDate: data.visaExpiredDate ? moment(data.visaExpiredDate) : null,
                            spouseName: data.spouseName,
                            spouseWorkingStatus: data.spouseWorkingStatus,
                            spouseOccupation: data.spouseOccupation,
                            motherName: data.motherName,
                            fatherName: data.fatherName,
                            nssfNumber: data.nssfNumber,
                            workbookNumber: data.workbookNumber,
                            workPermitNumber: data.workPermitNumber,
                            taxIdentificationNumber: data.taxIdentificationNumber,
                            contactNumber2: data.contactNumber2,
                            contactNumber3: data.contactNumber3,
                            emergencyContactName: data.emergencyContactName,
                            emergencyContactNumber: data.emergencyContactNumber,
                            email: data.email,
                            contactNumber: data.contactNumber,
                            pensionFund: data.pensionFund,
                            pensionFundType: data.pensionFundType,
                            providentFund: data.providentFund,
                            providentFundType: data.providentFundType,
                            insurance: data.insurance ? data.insurance.split(",") : [],
                            annualSalary: data.annualSalary,
                            seniority_severancePay: seniority_severancePay,
                            projectManagerId: data.projectManagerId,
                            jobGradeId: data.jobGradeId,
                            step: data.step,
                            jobLevelId: data.jobLevelId,
                            employeeType: data.employeeType,
                            typeOfWorker: data.typeOfWorker,
                            dutyStation: data.dutyStation,
                            unpaidSalary: data.unpaidSalary,
                            paid_seniority_udc: data.paid_seniority_udc,
                            workingDay: data.workingDay,
                            isNoticeTerminate: data.isNoticeTerminate,
                            noticeTerminateAt: data.noticeTerminateAt ? moment(data.noticeTerminateAt) : null,
                            terminationBenefit: data.terminationBenefit,
                            noticePeriodType: data.noticePeriodType,
                            noticePayload: data.noticePayload && data.noticePeriodType === "CUSTOM" ? data.noticePayload?.workingDay : null
                        });
                      
                        this.setState({
                            formData: data,
                            siblings: data.siblings,
                            inheritances: data.inheritances,
                            kids: data.kids.map(value => {
                                return {
                                    id: value.id,
                                    name: value.name,
                                    dob: value.dob,
                                    currentStatus: value.currentStatus,
                                    attachment: value.attachment ? [{
                                        uid: '-1',
                                        name: value.attachment,
                                        status: 'done',
                                        url: `${getHostURl()}/public/uploads/kids/${value.attachment}`,
                                    }] : []
                                }
                            }),
                            educations: data.educations,
                            certifications: data.certifications,
                            languages: data.languages,
                            skills: data.skills,
                            employeeBenefits: data.employeeBenefits,
                            budgetAllocations: data.budgetAllocations,
                            fileList: data.user?.photo ? [{
                                uid: '-1',
                                name: data.user.photo,
                                status: 'done',
                                url: `${getHostURl()}/public/uploads/profile/${data.user.photo}`,
                            }] : []
                        });
                    }
                })
                .finally(() => {
                    this.setState({
                        id,
                        loading: false,
                    });
                });
        }

    }

    onChangeSkills = (value, index, name) => {
        const skills = this.state.skills;
        skills[index][name] = value;
    }

    onChangeLanguages = (value, index, name) => {
        const languages = this.state.languages;
        languages[index][name] = value;
    }

    onChangeCertification = (value, index, name) => {
        const certifications = this.state.certifications;
        certifications[index][name] = value;
    }

    onChangeStep = (value) => {
        this.setState({currentStep: value});
        const access = document.getElementById(`profile-${value}`);
        access.scrollIntoView({behavior: "smooth"}, true)
    }

    onUploadFile = (options, stateName, endPoint, folderName) => {

        const {onSuccess, onError, file} = options;
        const formData = new FormData();
        const state = this.state[stateName];
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
            },
        };
        const duplicateFile = state.find((value) => value.name === file.name);
        if (duplicateFile) {
            Util.getInstance().sweetAlertMessage("This file already exists!", "warning");
        } else {
            formData.append("file", file, file.name);
            axios
                .post(`${getURl()}/file/v1/${endPoint}?clientId=${Util.getInstance().getClientId()}&employeeId=${this.props.id}`, formData, config)
                .then(() => {
                        onSuccess("Ok");

                        const data = {
                            uid: -Math.abs(Math.floor((Math.random() * 100000000000000) + 1)),
                            name: file.name,
                            status: 'done',
                            url: `${getHostURl()}/public/uploads/${Util.getInstance().getClientId()}/${folderName}/${this.props.id}/${file.name}`,
                        };

                        this.setState({
                            [stateName]: [...state, data]
                        })
                    }
                ).catch((err) => {
                onError({err});
                Util.getInstance().sweetAlertMessage(err.message, "error");
            });
        }
    };

    onRemoveFile = (file, stateName, endPoint) => {
        Util.getInstance()
            .sweetAlertConfirm(t("text_confrim"), "You won't be able to revert this!", ["Cancel", "Yes, delete it!"])
            .then((willDelete) => {
                if (willDelete) {
                    axios({
                        method: "DELETE",
                        url: `${getURl()}/file/v1/${endPoint}/${this.props.id}/${file.name}`,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
                        },
                    }).then(() => {
                        const state = this.state[stateName];
                        const stateIndex = state.findIndex((value) => value.name === file.name);
                        if (stateIndex >= 0) {
                            state.splice(stateIndex, 1);
                            this.setState({
                                [stateName]: [...state],
                            })
                        }
                    });
                }
            });
    }

    uploadProfilePhoto = (options) => {
        const {file} = options;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
            },
        };
        formData.append("photo", file, file.name);
        try {
            axios
                .post(`${getURl()}/file/v1/user/profile?employeeId=${this.props.id}`, formData, config)
                .then((response) => {
                    if (response.status === 200) {
                        this.setState({
                            fileList: [{
                                uid: `-${Date.now() + Math.random()}`,
                                name: response.data.filename,
                                status: 'done',
                                url: `${getHostURl()}/${response.data.path}?v=${Date.now()}`,
                            }]
                        })
                    }
                })
        } catch (err) {
            Util.getInstance().sweetAlertMessage(err.message, "error");
        }
    }

    beforeUpload = (file) => {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            Util.getInstance().sweetAlertMessage("Image must smaller than 2MB!", "warning");
        }
        return isLt2M;
    };

    onRemoveProfilePhoto = (file) => {
        axios({
            method: "DELETE",
            url: `${getURl()}/file/v1/user/profile?fileName=${this.props.id}.jpg`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
            },
        }).then(() => {
            const getClassName = document.getElementsByClassName("ant-upload-list-picture-card-container")[0];
            getClassName.style.display = "none";
            this.setState({
                fileList: []
            })
        })
    }

    uploadKidAttachment = (options, index) => {
        const {file} = options;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
            },
        };
        formData.append("attachment", file, file.name);
        try {
            axios
                .post(`${getURl()}/file/v1/kid_attachment`, formData, config)
                .then((response) => {
                    if (response.status === 200) {
                        const kids = this.state.kids;
                        kids[index]["attachment"] = [{
                            uid: '-1',
                            name: response.data.filename,
                            status: 'done',
                            url: `${getHostURl()}/${response.data.path}`,
                        }];

                        this.setState({
                            kids: [...kids]
                        })
                    }
                })
        } catch (err) {
            Util.getInstance().sweetAlertMessage(err.message, "error");
        }
    }

    onRemoveKidAttachment = (file, index) => {
        axios({
            method: "DELETE",
            url: `${getURl()}/file/v1/delete_kid?fileName=${file.name}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
            },
        }).then(() => {
            const kids = this.state.kids;
            kids[index]["attachment"] = [];
            this.setState({
                kids: [...kids]
            })
        })
    }


    onChangeEducation = (value, index, name) => {
        const educations = this.state.educations;
        educations[index][name] = value;
    }

    onChangeKidAndSiblingName = (value, index, name) => {
        if (name === "kid") {
            const kids = this.state.kids;
            kids[index]["name"] = value;
        } else {
            const siblings = this.state.siblings;
            siblings[index]["name"] = value;
        }

    }

    onChangeKidAndSiblingDate = (value, index, name) => {

        const dob = moment(value).format("YYYY-MM-DD");
        const age = moment().diff(dob, 'years');

        if (name === "kid") {
            const kids = this.state.kids;
            kids[index]["dob"] = dob;
            kids[index]["age"] = age;
            this.setState({
                kids: [...kids]
            })
        } else {
            const siblings = this.state.siblings;
            siblings[index]["dob"] = dob;
            siblings[index]["age"] = age;
            this.setState({
                siblings: [...siblings]
            })
        }
    }

    onChangeCurrentStatus = (value, index, name) => {
        if (name === "kid") {
            const kids = this.state.kids;
            kids[index]["currentStatus"] = value;
            this.setState({
                kids: [...kids]
            })
        } else {
            const siblings = this.state.siblings;
            siblings[index]["currentStatus"] = value;
        }
    }

    onChangeInheritanceName = (value, index, name) => {
        const inheritances = this.state.inheritances;
        inheritances[index][name] = value;
    }

    onChangeSubProjectCode = (subProjectCode, subProjectCodes, index) => {
        const subProject = subProjectCodes.find(value => value.subProject === subProjectCode);
        const budgetAllocations = this.state.budgetAllocations;
        if (subProject) {
            budgetAllocations[index]["subProjectCode"] = subProject.subProject;
            if (subProject.activityCode1) budgetAllocations[index]["activityCode1"] = subProject.activityCode1;
            if (subProject.activityCode2) budgetAllocations[index]["activityCode2"] = subProject.activityCode2;
            if (subProject.activityCode3) budgetAllocations[index]["activityCode3"] = subProject.activityCode3;
            if (subProject.activityCode4) budgetAllocations[index]["activityCode4"] = subProject.activityCode4;
        }
        this.setState({
            budgetAllocations
        })
    }

    onChangeBudgetAllocation = (value, index, name) => {
        const budgetAllocations = this.state.budgetAllocations;
        if (name === "project") {
            const foundCode = this.state.projects.find((project) => project.name === value);
            if(foundCode){
                budgetAllocations[index]["project"] = value;
                budgetAllocations[index]["subProject"] = foundCode.code;
                budgetAllocations[index]["payload"] = foundCode.payload;
                budgetAllocations[index]["subProjectCode"] = null;
            }else{
                budgetAllocations[index]["project"] = null;
				budgetAllocations[index]["subProject"] = null;
				budgetAllocations[index]["payload"] = null;
				budgetAllocations[index]["subProjectCode"] = null;
            } 
            this.setState({
                budgetAllocations: [...budgetAllocations],
            });
        } else {
            budgetAllocations[index][name] = value;
        }
    }

    onDeleteButtonBudgetAllocation = (index) => {
        Util.getInstance()
            .sweetAlertConfirm(t("text_confrim"), "You won't be able to revert this!", ["Cancel", "Yes, delete it!"])
            .then((willDelete) => {
                if (willDelete) {
                    const budgetAllocations = this.state.budgetAllocations;
                    budgetAllocations.splice(index, 1)
                    this.setState({
                        budgetAllocations: [...budgetAllocations]
                    })
                }
            });
    }

    onChangeBenifit = (value, index, name, record) => {
        const employeeBenefits = this.state.employeeBenefits;
        if (record && record.type === 2) {
            employeeBenefits[index][name] = Math.abs(value) * (-1);
        } else {
            if (value && value.value) {
                const found = this.state.payrollItems.find((payrollItem) => payrollItem.payrollItemId === value.value);
                employeeBenefits[index]["code"] = found.code;
                employeeBenefits[index]["type"] = found.type;
                employeeBenefits[index]["taxRate"] = found.taxRate;
                employeeBenefits[index]["payrollItemId"] = found.payrollItemId;
            } else {
                employeeBenefits[index][name] = value;
            }
        }
    }

    onChangeBenifitFix = (value, index, name) => {
        this.fixedEmployeeBenefits[index][name] = value;
    }

    onRemoveEmployeeBenifitButtton = (index, record) => {
        const employeeBenefits = this.state.employeeBenefits;
        if (record && "id" in record) {
            Util.getInstance()
                .sweetAlertConfirm(t("text_confrim"), "You won't be able to revert this!", ["Cancel", "Yes, delete it!"])
                .then((willDelete) => {
                    if (willDelete) {
                        record["status"] = 3;
                        this.employeeBenefitDelete.push(record)
                        employeeBenefits.splice(index, 1);
                        this.setState({
                            employeeBenefits: [...employeeBenefits]
                        });
                    }
                });
        } else {
            employeeBenefits.splice(index, 1);
            this.setState({
                employeeBenefits: [...employeeBenefits]
            });
        }
    }

    onNewButton = (stateName, properties) => {
        const state = this.state[stateName];
        let data = {};
        properties.forEach(property => {
            if (property === "offeredBy") {
                data["offeredBy"] = "ORGANIZATION";
            } else if (property === "attachment") {
                data["attachment"] = [];
            } else {
                data[property] = null;
            }
        });

        data["new"] = true;

        this.setState({
            [stateName]: [...state, data]
        });
    };

    onCancelButton = (index, stateName, updateData, properties) => {
        const state = this.state[stateName];
        this[updateData].forEach((value, updateIndex) => {
            if (value.index === index) {
                properties.forEach(property => {
                    state[index][property] = value[property]
                });
                if (value.id) state[index]["id"] = value.id
                this[updateData].splice(updateIndex, 1);
            }
        });
        delete state[index]["update"];
        delete state[index]["new"];
        this.setState({
            [stateName]: [...state]
        })
    }

    onDeleteButton = (index, stateName) => {
        Util.getInstance()
            .sweetAlertConfirm(t("text_confrim"), "You won't be able to revert this!", ["Cancel", "Yes, delete it!"])
            .then((willDelete) => {
                if (willDelete) {
                    const state = this.state[stateName];
                    state[index]["status"] = 3;
                    this.setState({
                        [stateName]: [...state]
                    })
                }
            });
    }

    onUpdateButton = (index, stateName, updateData) => {
        const state = this.state[stateName];
        state[index]["update"] = true;
        state[index]["new"] = true;
        state[index]["index"] = index;
        this[updateData].push({...state[index]})
        delete state[index]["index"];
        this.setState({
            [stateName]: [...state]
        });
    }

    onRemoveButtton = (index, stateName) => {
        const state = this.state[stateName];
        state.splice(index, 1);
        this.setState({
            [stateName]: [...state]
        });
    }

    onOKButton = (index, stateName, updateData) => {
        const state = this.state[stateName];
        this[updateData].forEach((value, updateIndex) => {
            if (value.index === index) {
                this[updateData].splice(updateIndex, 1);
            }
        });
        delete state[index]["update"];
        delete state[index]["new"];
        this.setState({
            [stateName]: [...state]
        })
    }

    handleCancel = () => {
        this.goBack();
    };

    goBack() {
        this.props.navigate("/employees");
    }

    onFinish = (values) => {
        const {formData} = this.state;
        const id = this.props.id;
        const kids = this.state.kids;
        const siblings = this.state.siblings;
        const inheritances = this.state.inheritances;
        const educations = this.state.educations;
        const certifications = this.state.certifications;
        const languages = this.state.languages;
        const skills = this.state.skills;
        const employeeBenefits = this.state.employeeBenefits;
        const budgetAllocations = this.state.budgetAllocations;
        let insurances = "";
        values["insurance"].forEach((value, index) => {
            if (index === values["insurance"].length - 1) {
                insurances += `${value}`
            } else {
                insurances += `${value},`
            }
        });
        values["insurance"] = insurances;

        this.state.employeeBenefits.forEach((value, index) => {
            delete values[`amount[${index}]`]
        });

        this.state.kids.forEach((value, index) => {
            delete values[`attachment${index}`]
        });

        

        this.setState({loadingButton: true});

        if (values["payrollCurrency"] === null) delete values["payrollCurrency"];
        delete values["password"];
        delete values["confirm"];

        if (values["noticePeriodType"] === "2WEEK") {
            values["noticePayload"] = {"workingDay": 10};
        } else if (values["noticePeriodType"] === "1MONTH") {
            values["noticePayload"] = {"workingDay": 22};
        } else if (values["noticePeriodType"] === "2MONTH") {
            values["noticePayload"] = {"workingDay": 44};
        } else if (values["noticePeriodType"] === "3MONTH") {
            values["noticePayload"] = {"workingDay": 66};
        } else {
            values["noticePayload"] = {"workingDay": values["noticePayload"]};
        }

        values["noticePayload"] = JSON.stringify(values["noticePayload"]);

        if (values["contractType"] === Enum.CONTRACT_TYPE.UDC) {
            if (formData.contractType !== Enum.CONTRACT_TYPE.FDC) {
                values["contractEndDate"] = null;
            } else if (values["contractEndDate"]) {
                values["contractEndDate"] = this.util.formatDateForMYSQL(values["contractEndDate"]);
            }
        } else {
            values["contractEndDate"] = this.util.formatDateForMYSQL(values["contractEndDate"]);
        }

        if (formData.contractType !== values["contractType"]) {
            values["contractChangedAt"] = this.util.formatDateForMYSQL(values["contractChangedAt"]);
        }

        if (values["status"] === 0) {
            values["lastWorkingDay"] = values["lastWorkingDay"] ? this.util.formatDateForMYSQL(values["lastWorkingDay"]) : null;
        } else {
            values["lastWorkingDay"] = null;
        }

        if (values["seniority_severancePay"]) {
            if (values["seniority_severancePay"] === "SENIORITY") {
                values["seniority"] = 1;
                values["severancePay"] = 0;
            } else {
                values["seniority"] = 0;
                values["severancePay"] = 1;
            }
        } else {
            values["seniority"] = 0;
            values["severancePay"] = 0;
        }

        if (values["seniority_severancePay"] === undefined) {
            values["seniority"] = null;
            values["severancePay"] = null;
        }

        delete values["seniority_severancePay"];

        this.state.fileList.length > 0 ? values["photo"] = this.state.fileList[0].name : values["photo"] = ""

        if (values["joinDate"]) values["joinDate"] = this.util.formatDateForMYSQL(values.joinDate);
        if (values["probationExpiredDate"]) values["probationExpiredDate"] = this.util.formatDateForMYSQL(values.probationExpiredDate);
        if (values["dob"]) values["dob"] = this.util.formatDateForMYSQL(values.dob);
        if (values["expiredDate"]) values["expiredDate"] = this.util.formatDateForMYSQL(values.expiredDate);
        if (values["passportExpiredDate"]) values["passportExpiredDate"] = this.util.formatDateForMYSQL(values.passportExpiredDate);
        if (values["passportIssuedDate"]) values["passportIssuedDate"] = this.util.formatDateForMYSQL(values.passportIssuedDate);
        if (values["visaExpiredDate"]) values["visaExpiredDate"] = this.util.formatDateForMYSQL(values.visaExpiredDate);

        values["phoneAllowance"] = this.fixedEmployeeBenefits[0];
        values["housingAllowance"] = this.fixedEmployeeBenefits[1];
        values["gasolineAllowance"] = this.fixedEmployeeBenefits[2];
        employeeBenefits.filter((value) => value.code || value.payrollItemId || value.id);
        values["employeeBenefits"] = this.employeeBenefitDelete.concat(employeeBenefits);

        values["actingById"] = values["actingById"] === undefined ? null : values["actingById"];
        values["actingStart"] = values["actingStart"] === undefined ? null : this.util.formatDateForMYSQL(values.actingStart);
        values["actingEnd"] = values["actingEnd"] === undefined ? null : this.util.formatDateForMYSQL(values.actingEnd);
        values["supervisorId"] = values["supervisorId"] === undefined ? null : values["supervisorId"];
        values["projectManagerId"] = values["projectManagerId"] === undefined ? null : values["projectManagerId"];
        values["headOfDepartmentId"] = values["headOfDepartmentId"] === undefined ? null : values["headOfDepartmentId"];
        values["fourthLineManagerId"] = values["fourthLineManagerId"] === undefined ? null : values["fourthLineManagerId"];
        values["fifthLineManagerId"] = values["fifthLineManagerId"] === undefined ? null : values["fifthLineManagerId"];
        values["jobGradeId"] = values["jobGradeId"] === undefined ? null : values["jobGradeId"];
        values["step"] = values["step"] === undefined ? null : values["step"];
        values["jobLevelId"] = values["jobLevelId"] === undefined ? null : values["jobLevelId"];
        values["teamId"] = values["teamId"] === undefined ? null : values["teamId"];
        values["teamId"] = values["teamId"] === undefined ? null : values["teamId"];
        values["isNoticeTerminate"] = values["isNoticeTerminate"] === undefined ? null : values["isNoticeTerminate"];
        values["terminationBenefit"] = values["terminationBenefit"] === undefined ? null : values["terminationBenefit"];
        values["lastModifiedSalaryAt"] = !values["lastModifiedSalaryAt"] ? null : this.util.formatDateForMYSQL(values["lastModifiedSalaryAt"]);
        values["annualSalary"] = values["annualSalary"] === undefined ? null : values["annualSalary"];
        values["dutyStation"] = values["dutyStation"] === undefined ? null : values["dutyStation"];

        values["kids"] = kids.filter((value) => (value.name || value.dob || value.currentStatus || value.id))
            .map((value) => {
                if (value.id) {
                    if (value.status) {
                        return {
                            id: value.id,
                            name: value.name,
                            dob: value.dob,
                            currentStatus: value.currentStatus,
                            attachment: value.attachment.length > 0 ? value.attachment[0].name : null,
                            status: value.status
                        }
                    } else {
                        return {
                            id: value.id,
                            name: value.name,
                            dob: value.dob,
                            currentStatus: value.currentStatus,
                            attachment: value.attachment.length > 0 ? value.attachment[0].name : null,
                        }
                    }

                } else {
                    return {
                        name: value.name,
                        dob: value.dob,
                        currentStatus: value.currentStatus,
                        attachment: value.attachment.length > 0 ? value.attachment[0].name : null,
                    }
                }
            });
        this.updateKidData.forEach((value, index) => {
            kids[value.index]["name"] = value.name
            kids[value.index]["currentStatus"] = value.currentStatus
            kids[value.index]["dob"] = value.dob
            kids[value.index]["attachment"] = value.attachment
            if (value.id) kids[index]["id"] = value.id

        });
        this.updateKidData = [];

        values["siblings"] = siblings.filter((value) => (value.name || value.dob || value.currentStatus || value.id));
        this.updateSiblingData.forEach((value, index) => {
            siblings[value.index]["name"] = value.name
            siblings[value.index]["currentStatus"] = value.currentStatus
            siblings[value.index]["dob"] = value.dob
            if (value.id) siblings[index]["id"] = value.id

        });
        this.updateSiblingData = [];

        values["inheritances"] = inheritances.filter((value) => (value.name || value.idCard || value.percentage || value.id));
        this.updateInheritanceData.forEach((value, index) => {
            inheritances[value.index]["name"] = value.name
            inheritances[value.index]["idCard"] = value.idCard
            inheritances[value.index]["percentage"] = value.percentage
            if (value.id) inheritances[index]["id"] = value.id

        });
        this.updateInheritanceData = [];

        values["educations"] = educations.filter((value) => (value.institute || value.degree || value.date || value.id));
        this.updateEducationData.forEach((value, index) => {
            educations[value.index]["institute"] = value.institute
            educations[value.index]["degree"] = value.degree
            educations[value.index]["date"] = value.date
            if (value.id) educations[index]["id"] = value.id

        });
        this.updateEducationData = [];

        values["certifications"] = certifications.filter((value) => (value.title || value.authority || value.date || value.id));
        this.updateCertificationData.forEach((value, index) => {
            certifications[value.index]["title"] = value.title
            certifications[value.index]["authority"] = value.authority
            certifications[value.index]["date"] = value.date
            if (value.id) certifications[index]["id"] = value.id

        });
        this.updateCertificationData = [];

        values["languages"] = languages.filter((value) => (value.title || value.proficiency || value.id));
        this.updateLanguageData.forEach((value, index) => {
            languages[value.index]["title"] = value.title
            languages[value.index]["proficiency"] = value.proficiency
            if (value.id) languages[index]["id"] = value.id
        });
        this.updateLanguageData = [];

        values["skills"] = skills.filter((value) => (value.title || value.level || value.id));
        this.updateSkillData.forEach((value, index) => {
            skills[value.index]["title"] = value.title
            skills[value.index]["level"] = value.level
            if (value.id) skills[index]["id"] = value.id

        });
        this.updateSkillData = [];

        values["budgetAllocations"] = budgetAllocations.filter((value, index) => {
            delete budgetAllocations[index]["update"];
            delete budgetAllocations[index]["new"];
            return (value.project || value.subProject || value.percentage || value.subProjectCode ||  value.payload || value.id)
        });
        this.updateBudgetAllocationData.forEach((value, index) => {
            budgetAllocations[value.index]["project"] = value.project;
            budgetAllocations[value.index]["subProject"] = value.subProject;
            budgetAllocations[value.index]["subProjectCode"] = value.subProjectCode;
            budgetAllocations[value.index]["percentage"] = value.percentage;
            budgetAllocations[value.index]["payload"] = value.payload;

            if (value.id) {
                budgetAllocations[index]["id"] = value.id;
            }
        });
        this.updateBudgetAllocationData = [];

        values["weekendDefinition"] = JSON.stringify(this.state.weekendDefinition);
        if(values["spouseWorkingStatus"] === undefined){
            values["spouseWorkingStatus"] = null
        }
        updateRecordById(id, values)
            .then(() => {
                swal({title: "Success!", text: "Employee information saved successfully!", icon: "success"});
            })
            .catch(err => {
                if (err?.response?.status === 403) {
                    localStorage.removeItem("ACCESS_TOKEN");
                    this.props.navigate("/signin");
                }
                if (err?.response?.data?.error?.message) {
                    swal({
                        title: err.response.data.error.message,
                        icon: "error",
                        dangerMode: true
                    });
                }
            })
            .finally(() => {
                this.setState({loadingButton: false,});
            });
    };

    onResetPasword = (values) => {
        resetPassword(this.state.formData.user?.id, values.confirm)
            .then(() => {
                this.goBack();
            })
            .finally(() => {
                this.setState({
                    loadingButton: false
                })
            });
    }

    onChange = (e) => {
        this.gender = e.target.value;
    };

    onChangeNoticePeriodType = (value) => {
        const visible = document.getElementById("notice-period-type-working-day");
        if (value === "CUSTOM") {
            visible.style.display = "";
        } else {
            visible.style.display = "none";
        }
    }


    onChangeContractType = (contractType) => {
        const {formData} = this.state;
        let requiredContractChangedAt = false;
        let requiredContractEndDate = false;

        const contractEndDateEl = document.getElementById("contract-end-date");
        if ((formData.contractType === Enum.CONTRACT_TYPE.FDC && contractType === Enum.CONTRACT_TYPE.UDC) || formData.contractChangedAt) {
            requiredContractChangedAt = true;
        } else {
            requiredContractChangedAt = false;
        }

        if (contractType === Enum.CONTRACT_TYPE.FDC || formData.contractType === Enum.CONTRACT_TYPE.FDC || formData.contractChangedAt) {
            contractEndDateEl.style.display = "";
            requiredContractEndDate = true;
        } else {
            contractEndDateEl.style.display = "none";
            requiredContractEndDate = false;
        }

        this.setState({
            requiredContractChangedAt,
            requiredContractEndDate
        });
    }

    onChangeNoticeTerminate = (value) => {
        const visible = document.getElementById("notice-period-type");
        if (value === 0) {
            visible.style.display = "";
            this.setState({requiredNoticePeriodType: true});
        } else {
            visible.style.display = "none";
            this.setState({requiredNoticePeriodType: false})
            this.props.form.setFieldsValue({
                noticePeriodType: undefined,
            });
        }
    }

    onChangeStatus = (values) => {
        const visible = document.getElementById("last-working-day");
        if (values === 0) {
            visible.style.display = "";
            this.setState({requiredLastWorkingDay: true})
        } else {
            visible.style.display = "none";
            this.setState({requiredLastWorkingDay: false})
        }
    }

    render() {
        const {
            loading,
            loadingButton,
            requiredContractEndDate,
            requiredNoticePeriodType,
            roles,
            departments,
            dutyStations,
            fifthLineManagers,
            fourthLineManagers,
            thirdLineManagers,
            supervisors,
            employeeBenefits,
            teams,
            passportTypes,
            visaTypes,
            nationalities,
            kids,
            inheritances,
            siblings,
            educations,
            certifications,
            languages,
            skills,
            payrollItems,
            certificateList,
            secondLineManagers,
            jobGrades,
            jobLavels,
            budgetAllocations,
            benefitFiles,
            fileList,
            requiredLastWorkingDay,
            projects
        } = this.state;

        return (
            <>
                {
                    Util.getInstance().hasPermission("edit", "employee")
                        ?
                        <Spin spinning={loading}>
                            <Row className="btn-navigation">
                                <Col span={12}>
                                    <div className="pull-left">
                                        <Button onClick={this.handleCancel}>
                                            <ArrowLeftOutlined/>
                                            {t("text_back")}
                                        </Button>
                                        <span className="title">
                                 {t("text_update_employee")}
                              </span>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="pull-right">
                                        <Button loading={loadingButton}
                                                onClick={() => document.getElementById("btn-sumbit-profile").click()}>{t("text_save")}</Button>
                                    </div>
                                </Col>
                            </Row>
                            <Card>
                                <Steps
                                    current={this.state.currentStep}
                                    onChange={this.onChangeStep}
                                >
                                    <Steps.Step title="Personal Information"/>
                                    <Steps.Step title="Contacts"/>
                                    <Steps.Step title="Education"/>
                                    <Steps.Step title="Job Profile"/>
                                    <Steps.Step title="Compensation & Benefit"/>
                                </Steps>
                            </Card>

                            <div className="scroll-employee" style={{backgroundColor: "#f2f4f4"}}>
                                <Form
                                    form={this.props.form}
                                    onFinish={this.onFinish}
                                    onFieldsChange={() => this.state.errorFields.length ? this.setState({errorFields: []}) : {}}
                                    onFinishFailed={error => this.setState({errorFields: error.errorFields})}
                                    layout="vertical"
                                    className="personal-form"
                                >
                                    <Button htmlType="submit" id="btn-sumbit-profile"
                                            style={{display: "none"}}>{t("text_save")}</Button>
                                    {
                                        this.state.errorFields.length > 0 &&
                                        <Card style={{marginBottom: 25}} id="error-card-info">
                                            {
                                                this.state.errorFields.map((errorField, key1) =>
                                                    errorField.errors.map((error, key2) => <Tag style={{marginTop: 5}}
                                                                                                key={`${key1}-${key2}`}
                                                                                                icon={
                                                                                                    <CloseCircleOutlined/>}
                                                                                                color="error"
                                                                                                onClick={() => {
                                                                                                    const access = document.getElementById(errorField.name[0]);
                                                                                                    access.scrollIntoView({behavior: "smooth"}, true)
                                                                                                }}>{error}</Tag>)
                                                )
                                            }
                                        </Card>
                                    }
                                    <Card title={t("text_personal_information")} bordered={false}
                                          className="employee-form" style={{marginBottom: 25}} id="profile-0">
                                        <Row gutter={25}>
                                            <Col lg={18}>
                                                <Row gutter={25}>
                                                    <Col lg={6}>
                                                        <InputText
                                                            label={t("text_employee_id")}
                                                            name="code"
                                                            placeholder={t("text_enter_a_unique_id")}
                                                            requiredMessage={t("text_enter_a_unique_id_i")}
                                                            className="width-input"
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_first_name")}
                                                            name="firstName"
                                                            placeholder={t("text_enter_first_name")}
                                                            requiredMessage={t("text_enter_first_name")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_last_name")}
                                                            name="lastName"
                                                            placeholder={t("text_enter_last_name")}
                                                            requiredMessage={t("text_enter_last_name")}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <SelectInput
                                                            name="gender"
                                                            label={t("text_gender")}
                                                            placeholder={t("text_gender")}
                                                            required={true}
                                                            valueKey="id"
                                                            dataSource={[
                                                                {id: Enum.GENDER.MALE, name: t("text_male")},
                                                                {id: Enum.GENDER.FEMALE, name: t("text_female")},
                                                                {id: Enum.GENDER.OTHER, name: t("text_other")}
                                                            ]}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_first_name_kh")}
                                                            name="firstNameKH"
                                                            placeholder={t("text_enter_first_name")}
                                                            requiredMessage={t("text_enter_first_name")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_last_name_kh")}
                                                            name="lastNameKH"
                                                            placeholder={t("text_enter_last_name")}
                                                            requiredMessage={t("text_enter_last_name")}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <SelectInput
                                                            name="maritalStatus"
                                                            label={t("text_marital_status")}
                                                            placeholder={t("text_select_marital_status")}
                                                            required={true}
                                                            valueKey="id"
                                                            dataSource={[
                                                                {id: "SINGLE", name: t("text_single")},
                                                                {id: "MARRIED", name: t("text_Married")},
                                                                {id: "DIVORCED", name: t("text_separated")},
                                                            ]}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_current_address")}
                                                            name="address"
                                                            placeholder={t("text_enter_current_address")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputDate
                                                            name="dob"
                                                            required={true}
                                                            allowClear={false}
                                                            errorMessage={t("text_please_select_date_of_birth")}
                                                            placeholder={t("text_dd_mm_yyyy")}
                                                            style={{width: "100%"}}
                                                            format="DD/MM/YYYY"
                                                            label={t("text_date_of_birth")}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <InputText
                                                            label={t("text_place_of_birth")}
                                                            name="placeOfBirth"
                                                            placeholder={t("text_enter_place_of_birth")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_national_id_number")}
                                                            name="nationIDNumber"
                                                            placeholder={t("text_enter_national_id_number")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputDate
                                                            name="expiredDate"
                                                            placeholder={t("text_dd_mm_yyyy")}
                                                            style={{width: "100%"}}
                                                            format="DD/MM/YYYY"
                                                            label={t("text_expired_date")}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <SelectInput
                                                            name="nationalityId"
                                                            label={t("text_nationality")}
                                                            placeholder={t("text_select_nationality")}
                                                            valueKey="id"
                                                            dataSource={nationalities}
                                                            allowClear={true}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_ethnicity")}
                                                            name="ethnicity"
                                                            placeholder={t("text_enter_ethnicity")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            label={t("text_religious")}
                                                            name="religious"
                                                            placeholder={t("text_enter_religious")}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <InputText
                                                            name="bankAccNumber"
                                                            placeholder={t("text_bank_acc_no")}
                                                            label={t("text_bank_acc_no")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            name="notifyEmail"
                                                            placeholder={t("text_enter_notify_email")}
                                                            label={t("text_notify_email")}
                                                            requiredMessage={t("text_enter_notify_email")}
                                                        />
                                                    </Col>
                                                    <Col lg={6} offset={2}>
                                                        <InputText
                                                            name="userName"
                                                            placeholder={t("text_enter_account")}
                                                            label={t("text_username")}
                                                            requiredMessage={t("text_enter_account")}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg={6}>
                                                <div className={"upload-profile-photo"}>
                                                    <Upload
                                                        customRequest={this.uploadProfilePhoto}
                                                        listType="picture-card"
                                                        fileList={fileList}
                                                        onRemove={this.onRemoveProfilePhoto}
                                                        beforeUpload={this.beforeUpload}
                                                    >

                                                        {fileList.length < 1 && '+ Upload Profile'}

                                                    </Upload>
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_passport_information")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="passportTypeId"
                                                    label={t("text_passport_type")}
                                                    placeholder={t("text_select_passport_type")}
                                                    valueKey="id"
                                                    dataSource={passportTypes}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_passport_number")}
                                                    name="passportNumber"
                                                    placeholder={t("text_enter_passport_number")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="passportIssuedDate"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_date_of_issued")}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_place_of_issued")}
                                                    name="passportIssuedPlace"
                                                    placeholder={t("text_enter_place_of_issued")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="passportExpiredDate"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_expired_date")}
                                                />
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_visa_information")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="visaTypeId"
                                                    label={t("text_visa_type")}
                                                    placeholder={t("text_select_visa_type")}
                                                    valueKey="id"
                                                    dataSource={visaTypes}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_visa_number")}
                                                    name="visaNumber"
                                                    placeholder={t("text_enter_visa_number")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="visaExpiredDate"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_expired_date")}
                                                />
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_spouse_and_kids_information")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_spouse_name")}
                                                    name="spouseName"
                                                    placeholder={t("text_enter_spouse_name")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="spouseWorkingStatus"
                                                    label={t("text_working")}
                                                    allowClear={true}
                                                    placeholder={t("text_select_working")}
                                                    valueKey="id"
                                                    dataSource={[
                                                        {id: 0, name: t("text_No")},
                                                        {id: 1, name: t("text_yes")},
                                                    ]}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_occupation")}
                                                    name="spouseOccupation"
                                                    placeholder={t("text_enter_spouse_occupation")}
                                                />
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `kids${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={kids.every(value => value.status) ? [] : kids}
                                                        columns={[
                                                            {
                                                                title: t("text_kid_name"),
                                                                dataIndex: "name",
                                                                key: "name",
                                                                render: (name, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={name}
                                                                                    placeholder={t("text_kid_name")}
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeKidAndSiblingName(event.target.value, index, "kid")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return name;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_date_of_birth"),
                                                                dataIndex: "dob",
                                                                key: "dob",
                                                                width: 251,
                                                                render: (dob, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputDate
                                                                                    defaultValue={dob && moment(dob)}
                                                                                    placeholder={t("text_dd_mm_yyyy")}
                                                                                    format="DD/MM/YYYY"
                                                                                    style={{marginBottom: 0}}
                                                                                    onChange={(value) => this.onChangeKidAndSiblingDate(value, index, "kid")}
                                                                                    isAutoSelect={true}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return dob && Util.getInstance().formatDate(dob)
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_age"),
                                                                dataIndex: "age",
                                                                key: "age",
                                                                render: (age, record) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return <div style={{
                                                                                alignItems: "center",
                                                                                display: "flex"
                                                                            }}> {record.dob && moment().diff(record.dob, 'years')} </div>
                                                                        } else {
                                                                            return record.dob && moment().diff(record.dob, 'years');
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_current_status"),
                                                                dataIndex: "currentStatus",
                                                                key: "currentStatus",
                                                                render: (currentStatus, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <SelectInput
                                                                                    placeholder={t("text_select_current_status")}
                                                                                    allowClear={true}
                                                                                    valueKey="id"
                                                                                    style={{marginBottom: 0}}
                                                                                    onChange={(value) => this.onChangeCurrentStatus(value, index, "kid")}
                                                                                    defaultValue={currentStatus}
                                                                                    isAutoSelect={true}
                                                                                    dataSource={[
                                                                                        {
                                                                                            id: "UNDER_CONTROLL",
                                                                                            name: t("text_under_controll")
                                                                                        },
                                                                                        {
                                                                                            id: "OUT_OF_CONTROLL",
                                                                                            name: t("text_out_of_controll")
                                                                                        },
                                                                                    ]}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return currentStatus === "UNDER_CONTROLL" ? t("text_under_controll") : currentStatus === "OUT_OF_CONTROLL" ? t("text_out_of_controll") : null;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: "Attachment",
                                                                dataIndex: "attachment",
                                                                key: "attachment",
                                                                render: (attachment, record, index) => {
                                                                    this.props.form.setFieldsValue({
                                                                        [`attachment${index}`]: attachment.length > 0 ? attachment : undefined
                                                                    })
                                                                    return (
                                                                        <Form.Item
                                                                            name={`attachment${index}`}
                                                                            rules={[
                                                                                {
                                                                                    required: ((record.dob && moment().diff(record.dob, 'years')) > 18 && record.currentStatus === "UNDER_CONTROLL") ? true : false,
                                                                                    message: "Please upload file!",
                                                                                },
                                                                            ]}
                                                                            style={{marginBottom: 0}}
                                                                        >
                                                                            <div className={"upload-kid-attachment"}>
                                                                                <Upload
                                                                                    customRequest={(options) => this.uploadKidAttachment(options, index)}
                                                                                    fileList={attachment}
                                                                                    onRemove={(file) => this.onRemoveKidAttachment(file, index)}
                                                                                >

                                                                                    {attachment.length < 1 && <Button
                                                                                        icon={<PaperClipOutlined/>}
                                                                                        style={{border: "1px dotted #8F989F"}}>attachment</Button>}

                                                                                </Upload>
                                                                            </div>
                                                                        </Form.Item>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "action",
                                                                key: "action",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "kids", "updateKidData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "kids", "updateKidData", ["name", "currentStatus", "dob", "attachment"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "kids")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "kids", "updateKidData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "kids")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("kids", ["name", "currentStatus", "dob", "attachment"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_sibling_parents_and_other_information")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_mother_name")}
                                                    name="motherName"
                                                    placeholder={t("text_enter_mother_name")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_father_name")}
                                                    name="fatherName"
                                                    placeholder={t("text_enter_father_name")}
                                                />
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `siblings${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={siblings.every(value => value.status) ? [] : siblings}
                                                        columns={[
                                                            {
                                                                title: t("text_sibling_name"),
                                                                dataIndex: "name",
                                                                key: "name",
                                                                render: (name, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={name}
                                                                                    placeholder="Enter name of sibling"
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeKidAndSiblingName(event.target.value, index, "sibling")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return name;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_date_of_birth"),
                                                                dataIndex: "dob",
                                                                key: "dob",
                                                                width: 251,
                                                                render: (dob, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputDate
                                                                                    defaultValue={dob && moment(dob)}
                                                                                    placeholder={t("text_dd_mm_yyyy")}
                                                                                    format="DD/MM/YYYY"
                                                                                    style={{marginBottom: 0}}
                                                                                    onChange={(value) => this.onChangeKidAndSiblingDate(value, index, "sibling")}
                                                                                    isAutoSelect={true}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return dob && Util.getInstance().formatDate(dob)
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_age"),
                                                                dataIndex: "age",
                                                                key: "age",
                                                                render: (age, record) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return <div style={{
                                                                                alignItems: "center",
                                                                                display: "flex"
                                                                            }}> {record.dob && moment().diff(record.dob, 'years')} </div>
                                                                        } else {
                                                                            return record.dob && moment().diff(record.dob, 'years');
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_current_status"),
                                                                dataIndex: "currentStatus",
                                                                key: "currentStatus",
                                                                render: (currentStatus, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <SelectInput
                                                                                    placeholder={t("text_select_current_status")}
                                                                                    valueKey="id"
                                                                                    style={{marginBottom: 0}}
                                                                                    allowClear={true}
                                                                                    onChange={(value) => this.onChangeCurrentStatus(value, index, "sibling")}
                                                                                    defaultValue={currentStatus}
                                                                                    isAutoSelect={true}
                                                                                    dataSource={[
                                                                                        {
                                                                                            id: "UNDER_CONTROLL",
                                                                                            name: t("text_under_controll")
                                                                                        },
                                                                                        {
                                                                                            id: "OUT_OF_CONTROLL",
                                                                                            name: t("text_out_of_controll")
                                                                                        },
                                                                                    ]}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return currentStatus === "UNDER_CONTROLL" ? t("text_under_controll") : currentStatus === "OUT_OF_CONTROLL" ? t("text_out_of_controll") : null;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "action",
                                                                key: "action",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "siblings", "updateSiblingData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "siblings", "updateSiblingData", ["name", "currentStatus", "dob"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "siblings")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "siblings", "updateSiblingData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "siblings")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("siblings", ["name", "currentStatus", "dob"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_nssf_number")}
                                                    name="nssfNumber"
                                                    placeholder={t("text_enter_nssf_number")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_workbook_number")}
                                                    name="workbookNumber"
                                                    placeholder={t("text_enter_workbook_number")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_workpermit_number")}
                                                    name="workPermitNumber"
                                                    placeholder={t("text_enter_workpermit_number")}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_tax_identification_number")}
                                                    name="taxIdentificationNumber"
                                                    placeholder={t("text_enter_tax_identification_number")}
                                                />
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_next_of_king_information")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `inheritances${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={inheritances.every(value => value.status) ? [] : inheritances}
                                                        columns={[
                                                            {
                                                                title: t("text_name"),
                                                                dataIndex: "name",
                                                                key: "name",
                                                                render: (name, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={name}
                                                                                    placeholder={t("text_name")}
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeInheritanceName(event.target.value, index, "name")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return name;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_national_id_number"),
                                                                dataIndex: "idCard",
                                                                key: "idCard",
                                                                render: (idCard, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={idCard}
                                                                                    placeholder={t("text_enter_national_id_number")}
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeInheritanceName(event.target.value, index, "idCard")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return idCard;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_inheritance"),
                                                                dataIndex: "percentage",
                                                                key: "percentage",
                                                                render: (percentage, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <NumberInput
                                                                                    defaultValue={percentage}
                                                                                    placeholder={t("text_enter_inheritances")}
                                                                                    style={{marginBottom: 0}}
                                                                                    max={100}
                                                                                    onChange={(value) => this.onChangeInheritanceName(value, index, "percentage")}
                                                                                    isAutoSelect={true}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return percentage && `${percentage}%`
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "action",
                                                                key: "action",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "inheritances", "updateInheritanceData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "inheritances", "updateInheritanceData", ["name", "idCard", "percentage"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "inheritances")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "inheritances", "updateInheritanceData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "inheritances")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("inheritances", ["name", "idCard", "percentage"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                    <Card title={t("text_contacts_information")} bordered={false}
                                          className="employee-form" style={{marginBottom: 25}} id="profile-1">
                                        <Row gutter={25}>
                                            <Col lg={6}>
                                                <InputText
                                                    label={t("text_contact_number_1")}
                                                    name="contactNumber"
                                                    placeholder={t("text_enter_contact_number_1")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_contact_number_2")}
                                                    name="contactNumber2"
                                                    placeholder={t("text_enter_contact_number_2")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_contact_number_3")}
                                                    name="contactNumber3"
                                                    placeholder={t("text_enter_contact_number_3")}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Item
                                                    name="email"
                                                    label={t("text_personal_email")}
                                                    rules={[
                                                        {
                                                            required: true
                                                        },
                                                        {
                                                            type: "email",
                                                            message: "Email is not valid"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={t("text_enter_personal_email")}/>
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_emergency_contact_name")}
                                                    name="emergencyContactName"
                                                    placeholder={t("text_enter_emergency_contact_name")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_emergency_contact_number")}
                                                    name="emergencyContactNumber"
                                                    placeholder={t("text_enter_emergency_contact_number")}
                                                />
                                            </Col>
                                        </Row>
                                    </Card>
                                    <Card title={t("text_education_information")} bordered={false}
                                          className="employee-form" style={{marginBottom: 25}} id="profile-2">
                                        <Row gutter={25}>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_national_education")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `educations${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={educations.every(value => value.status) ? [] : educations}
                                                        columns={[
                                                            {
                                                                title: t("text_institute"),
                                                                dataIndex: "institute",
                                                                key: "institute",
                                                                render: (institute, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={institute}
                                                                                    placeholder={t("text_enter_institute")}
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeEducation(event.target.value, index, "institute")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return institute;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_degree"),
                                                                dataIndex: "degree",
                                                                key: "degree",
                                                                render: (degree, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={degree}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_eg_bachelor_of_arts_in_english")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeEducation(event.target.value, index, "degree")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return degree;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_date_s"),
                                                                dataIndex: "date",
                                                                key: "date",
                                                                render: (date, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={date}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_date_s_placeholder")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeEducation(event.target.value, index, "date")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return date;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "id",
                                                                key: "id",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "educations", "updateEducationData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "educations", "updateEducationData", ["institute", "degree", "date"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (

                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "educations")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "educations", "updateEducationData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "educations")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("educations", ["institute", "degree", "date"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_short_course_certification")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `certifications${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={certifications.every(value => value.status) ? [] : certifications}
                                                        columns={[
                                                            {
                                                                title: t("text_title"),
                                                                dataIndex: "title",
                                                                key: "title",
                                                                render: (title, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={title}
                                                                                    placeholder={t("text_name_of_certification")}
                                                                                    style={{marginBottom: 0}}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeCertification(event.target.value, index, "title")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return title;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_certifying_authority"),
                                                                dataIndex: "authority",
                                                                key: "authority",
                                                                render: (authority, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={authority}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_certifying_authority_placeholder")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeCertification(event.target.value, index, "authority")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return authority
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_date_s"),
                                                                dataIndex: "date",
                                                                key: "date",
                                                                render: (date, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={date}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_date_s_placeholder")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeCertification(event.target.value, index, "date")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return date
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "id",
                                                                key: "id",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "certifications", "updateCertificationData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "certifications", "updateCertificationData", ["title", "authority", "date"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "certifications")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "certifications", "updateCertificationData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "certifications")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("certifications", ["title", "authority", "date"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    marginBottom: 15
                                                }}>{t("text_attachment_of_education_certificate")}</p>
                                            </Col>

                                            <Col lg={24}>
                                                <div id="employee-upload-file">
                                                    <Dragger
                                                        customRequest={(options) => this.onUploadFile(options, "certificateList", "upload_certificate", "certificates")}
                                                        multiple={true}
                                                        onRemove={(file) => this.onRemoveFile(file, "certificateList", "delete_certificate?path=certificates")}
                                                        fileList={certificateList}

                                                    >
                                                        <p className="ant-upload-drag-icon">
                                                            <PaperClipOutlined style={{fontSize: 35}}/>
                                                        </p>
                                                        <p className="ant-upload-text" style={{
                                                            fontSize: 16,
                                                            fontWeight: 400,
                                                            color: "#000000",
                                                            letterpacing: "-0.38px"
                                                        }}>Click or drag file to this area to upload</p>
                                                        <p className="ant-upload-hint">
                                                            Support for a single or bulk upload. Strictly prohibit from
                                                            uploading education or other
                                                            course files
                                                        </p>
                                                    </Dragger>
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_languages")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `languages${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={languages.every(value => value.status) ? [] : languages}
                                                        columns={[
                                                            {
                                                                title: t("text_language"),
                                                                dataIndex: "title",
                                                                key: "title",
                                                                render: (title, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={title}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_eg_khmer")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeLanguages(event.target.value, index, "title")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return title;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_proficiency"),
                                                                dataIndex: "proficiency",
                                                                key: "proficiency",
                                                                render: (proficiency, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    style={{marginBottom: 0}}
                                                                                    defaultValue={proficiency}
                                                                                    placeholder={t("text_proficiency_placeholder")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeLanguages(event.target.value, index, "proficiency")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return proficiency
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "id",
                                                                key: "id",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "languages", "updateLanguageData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "languages", "updateLanguageData", ["title", "proficiency"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "languages")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "languages", "updateLanguageData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "languages")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("languages", ["title", "proficiency"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_skills")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `skills${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={skills.every(value => value.status) ? [] : skills}
                                                        columns={[
                                                            {
                                                                title: t("text_title"),
                                                                dataIndex: "title",
                                                                key: "title",
                                                                render: (title, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={title}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_eg_computer_skill")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeSkills(event.target.value, index, "title")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return title
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_level"),
                                                                dataIndex: "level",
                                                                key: "level",
                                                                render: (level, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <InputText
                                                                                    defaultValue={level}
                                                                                    style={{marginBottom: 0}}
                                                                                    placeholder={t("text_level_placeholder")}
                                                                                    isAutoSelect={true}
                                                                                    onChange={(event) => this.onChangeSkills(event.target.value, index, "level")}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return level
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "id",
                                                                key: "id",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "skills", "updateSkillData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "skills", "updateSkillData", ["title", "level"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "skills")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "skills", "updateSkillData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButton(index, "skills")}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        rowClassName={record => record.status && "hidded-custom-row"}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("skills", ["title", "level"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                    <Card title={t("text_approval_setting")} className="employee-form" bordered={false}
                                          style={{marginBottom: 25}} id="approval-setting-3">
                                        <Row gutter={25}>
                                            <Col lg={6}>
                                                <Form.Item
                                                    name="approver1Id"
                                                    label={t("text_approval_leave_ot")}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Who approves leave and overtime requests?",
                                                        }
                                                    ]}
                                                >
                                                    <Select
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        allowClear={true}
                                                        fieldNames={{label: "name", value: "id"}}
                                                        placeholder="Who approves leave and overtime requests?"
                                                        options={[
                                                            {
                                                                name: "5th Line Managers",
                                                                options: fifthLineManagers
                                                            },
                                                            {
                                                                name: "4th Line Managers",
                                                                options: fourthLineManagers
                                                            },
                                                            {
                                                                name: "3rd Line Managers",
                                                                options: thirdLineManagers
                                                            },
                                                            {
                                                                name: "2nd Line Managers",
                                                                options: secondLineManagers
                                                            },
                                                            {
                                                                name: "1st Line Managers",
                                                                options: supervisors
                                                            }
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <Form.Item
                                                    name="approver2Id"
                                                    label={t("text_approval_pdd")}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Who approves PDD?"
                                                        }
                                                    ]}
                                                >
                                                    <Select
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        allowClear={true}
                                                        fieldNames={{label: "name", value: "id"}}
                                                        placeholder="Who approves PDD?"
                                                        options={[
                                                            {
                                                                name: "5th Line Managers",
                                                                options: fifthLineManagers
                                                            },
                                                            {
                                                                name: "4th Line Managers",
                                                                options: fourthLineManagers
                                                            },
                                                            {
                                                                name: "3rd Line Managers",
                                                                options: thirdLineManagers
                                                            },
                                                            {
                                                                name: "2nd Line Managers",
                                                                options: secondLineManagers
                                                            },
                                                            {
                                                                name: "1st Line Managers",
                                                                options: supervisors
                                                            }
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <Form.Item
                                                    name="actingById"
                                                    label={t("text_acting_by")}
                                                >
                                                    <Select
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        allowClear={true}
                                                        fieldNames={{label: "name", value: "id"}}
                                                        placeholder="Select employees who are currently acting."
                                                        options={[
                                                            {
                                                                name: "5th Line Managers",
                                                                options: fifthLineManagers
                                                            },
                                                            {
                                                                name: "4th Line Managers",
                                                                options: fourthLineManagers
                                                            },
                                                            {
                                                                name: "3rd Line Managers",
                                                                options: thirdLineManagers
                                                            },
                                                            {
                                                                name: "2nd Line Managers",
                                                                options: secondLineManagers
                                                            },
                                                            {
                                                                name: "1st Line Managers",
                                                                options: supervisors
                                                            }
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6}>
                                                <InputDate
                                                    name="actingStart"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_acting_start")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="actingEnd"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_acting_end")}
                                                />
                                            </Col>
                                        </Row>
                                    </Card>
                                    <Card title={t("text_job_profile")} className="employee-form" bordered={false}
                                          style={{marginBottom: 25}} id="profile-3">
                                        <Row gutter={25}>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="supervisorId"
                                                    allowClear={true}
                                                    placeholder={t("text_select_1st_line_manager")}
                                                    label={t("text_1st_line_manager")}
                                                    valueKey="id"
                                                    errorMessage={t("text_please_select_1st_line_manager")}
                                                    dataSource={supervisors}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="projectManagerId"
                                                    placeholder={t("text_select_2nd_line_manager")}
                                                    label={t("text_2nd_line_manager")}
                                                    valueKey="id"
                                                    dataSource={secondLineManagers}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="headOfDepartmentId"
                                                    placeholder={t("text_select_3rd_line_manager")}
                                                    label={t("text_3rd_line_manager")}
                                                    valueKey="id"
                                                    dataSource={thirdLineManagers}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="fourthLineManagerId"
                                                    placeholder={t("text_select_4th_line_manager")}
                                                    label={t("text_4th_line_manager")}
                                                    valueKey="id"
                                                    dataSource={fourthLineManagers}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="fifthLineManagerId"
                                                    placeholder={t("text_select_5th_line_manager")}
                                                    label={t("text_5th_line_manager")}
                                                    valueKey="id"
                                                    dataSource={fifthLineManagers}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputText
                                                    label={t("text_position")}
                                                    name="position"
                                                    placeholder={t("text_position_placeholder")}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="jobGradeId"
                                                    placeholder={t("text_select_job_grade")}
                                                    label={t("text_job_grade")}
                                                    valueKey="id"
                                                    dataSource={jobGrades}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="step"
                                                    placeholder={t("text_select_step")}
                                                    label={t("text_step")}
                                                    valueKey="id"
                                                    dataSource={Array.from(Array(9).keys()).map(value => ({
                                                        id: value + 1,
                                                        label: value + 1
                                                    }))}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="jobLevelId"
                                                    placeholder={t("text_select_job_level")}
                                                    label={t("text_job_level")}
                                                    valueKey="id"
                                                    dataSource={jobLavels}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <InputDate
                                                    name="joinDate"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_date_of_employment")}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="probationExpiredDate"
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    required={false}
                                                    label={t("text_probation_expired_date")}
                                                    disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="employeeType"
                                                    placeholder={t("text_select_employee_type")}
                                                    label={t("text_employee_type")}
                                                    valueKey="id"
                                                    allowClear={false}
                                                    required={true}
                                                    dataSource={[
                                                        {id: "NATIONAL", name: "National"},
                                                        {id: "INTERNATIONAL", name: "International"}
                                                    ]}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="typeOfWorker"
                                                    placeholder={t("text_select_type_of_worker")}
                                                    label={t("text_type_of_worker")}
                                                    valueKey="id"
                                                    required={true}
                                                    allowClear={false}
                                                    dataSource={[
                                                        {id: "RESIDENT", name: "Resident"},
                                                        {id: "NON-RESIDENT", name: "Non-Resident"}
                                                    ]}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="teamId"
                                                    label={t("text_team")}
                                                    placeholder={t("text_select_team")}
                                                    valueKey="id"
                                                    dataSource={teams}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="departmentId"
                                                    placeholder={t("text_select_department_programme")}
                                                    label={t("text_department_programme")}
                                                    valueKey="id"
                                                    dataSource={departments}
                                                    allowClear={true}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <SelectInput
                                                    name="dutyStation"
                                                    placeholder={t("text_select_duty_station")}
                                                    label={t("text_duty_station")}
                                                    valueKey="name"
                                                    allowClear={true}
                                                    dataSource={dutyStations}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="contractType"
                                                    onChange={this.onChangeContractType}
                                                    label={t("text_contract_type")}
                                                    required={true}
                                                    errorMessage={"Please select contract type!"}
                                                    placeholder={t("text_select_contract_type")}
                                                    valueKey="id"
                                                    dataSource={[
                                                        {id: Enum.CONTRACT_TYPE.UDC, name: t("text_udc")},
                                                        {id: Enum.CONTRACT_TYPE.FDC, name: t("text_fdc")},
                                                        {id: Enum.CONTRACT_TYPE.VOLUNTEER, name: t("text_volunteer")},
                                                        {id: Enum.CONTRACT_TYPE.CONSULTANT, name: t("text_consultant")},
                                                        {id: Enum.CONTRACT_TYPE.INTERNSHIP, name: t("text_internship")},
                                                    ]}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="workingDay"
                                                    placeholder={t("text_select_working_day")}
                                                    label={t("text_working_day")}
                                                    required={true}
                                                    valueKey="id"
                                                    dataSource={[
                                                        {id: "MTOF", name: "Working day (M-F)"},
                                                        {id: "OPERATION_CALENDAR", name: "Operations Calendar"}
                                                    ]}
                                                />
                                            </Col>

                                            <Col lg={6}>
                                                <SelectInput
                                                    name="roleId"
                                                    label={t("text_role")}
                                                    placeholder={t("text_select_role_component")}
                                                    required={true}
                                                    errorMessage={t("text_please_select_role")}
                                                    valueKey="id"
                                                    dataSource={roles}
                                                />
                                            </Col>

                                            <Col lg={6} offset={2}>
                                                <SelectInput
                                                    name="status"
                                                    label={t("text_employment_status")}
                                                    placeholder={t("text_select_employment_status")}
                                                    allowClear={true}
                                                    onChange={this.onChangeStatus}
                                                    valueKey="id"
                                                    dataSource={[
                                                        {id: 1, name: t("text_active")},
                                                        {id: 0, name: t("text_inactive")},
                                                        {id: 4, name: "Maternity Leave"},
                                                        {id: 5, name: "Sicking Leave"}
                                                    ]}
                                                />
                                            </Col>

                                            <Col lg={6} offset={2} id="contract-end-date" style={{display: "none"}}>
                                                <InputDate
                                                    name="contractEndDate"
                                                    required={requiredContractEndDate ? requiredContractEndDate : false}
                                                    allowClear={false}
                                                    errorMessage={t("text_please_select_contract_end_date")}
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_contract_end_date")}
                                                    disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
                                                />
                                            </Col>

                                            <Col lg={6} offset={requiredContractEndDate ? 0 : 2} id="last-working-day"
                                                 style={{display: "none"}}>
                                                <InputDate
                                                    id="last-working-day"
                                                    name="lastWorkingDay"
                                                    required={requiredLastWorkingDay ? requiredLastWorkingDay : false}
                                                    errorMessage={t("text_please_select_last_working_day")}
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_last_working_day")}
                                                    disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
                                                    style={{width: "100%"}}
                                                    allowClear={false}
                                                />
                                            </Col>

                                            {
                                                this.state.requiredContractChangedAt &&
                                                <Col lg={6} id="contract-changed-at">
                                                    <InputDate
                                                        name="contractChangedAt"
                                                        allowClear={true}
                                                        required={true}
                                                        errorMessage={t("text_please_select_contract_changed_at")}
                                                        placeholder={t("text_dd_mm_yyyy")}
                                                        style={{width: "100%"}}
                                                        format="DD/MM/YYYY"
                                                        label={t("text_contract_changed_at")}
                                                        disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
                                                    />
                                                </Col>
                                            }

                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_denors_budget_allocation")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col lg={24}>
                                                <div style={{marginBottom: 25}}>
                                                    <Table
                                                        rowKey={() => `budgetAllocations${Date.now() + Math.random()}`}
                                                        style={{marginTop: 15}}
                                                        dataSource={budgetAllocations}
                                                        columns={[
                                                            {
                                                                title: t("text_project_name_code"),
                                                                dataIndex: "project",
                                                                key: "project",
                                                                render: (project, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <SelectInput
                                                                                    placeholder={t("text_project_name_code")}
                                                                                    style={{marginBottom: 0}}
                                                                                    valueKey="name"
                                                                                    onChange={(value) => this.onChangeBudgetAllocation(value, index, "project")}
                                                                                    defaultValue={project}
                                                                                    isAutoSelect={true}
                                                                                    allowClear={true}
                                                                                    dataSource={projects}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return project;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_project_code"),
                                                                dataIndex: "subProject",
                                                                key: "subProject",
                                                                render: (subProject) => subProject
                                                            },
                                                            {
                                                                title: t("text_sub_project_code"),
                                                                dataIndex: "subProjectCode",
                                                                key: "subProjectCode",
                                                                render: (subProjectCode, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new ) {
                                                                            const subProjectCodes = record.payload ? record.payload : [];
                                                                            return <SelectInput
                                                                                placeholder={t("text_sub_project_code")}
                                                                                style={{marginBottom: 0}}
                                                                                valueKey="subProject"
                                                                                nameKey="subProject"
                                                                                onChange={(subProjectCode) => this.onChangeSubProjectCode(subProjectCode, subProjectCodes, index)}
                                                                                defaultValue={subProjectCode}
                                                                                isAutoSelect={true}
                                                                                allowClear={true}
                                                                                dataSource={subProjectCodes}
                                                                            />
                                                                        } else {
                                                                            return subProjectCode;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_percentage_of_allocate"),
                                                                dataIndex: "percentage",
                                                                key: "percentage",
                                                                width: 200,
                                                                render: (percentage, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            return (
                                                                                <NumberInput
                                                                                    defaultValue={percentage}
                                                                                    placeholder={t("text_enter_percentage_of_allocate")}
                                                                                    style={{marginBottom: 0}}
                                                                                    max={100}
                                                                                    onChange={(value) => this.onChangeBudgetAllocation(value, index, "percentage")}
                                                                                    isAutoSelect={true}
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return percentage;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                title: t("text_action"),
                                                                dataIndex: "id",
                                                                key: "id",
                                                                width: 160,
                                                                align: "center",
                                                                render: (id, record, index) => {
                                                                    if (!record.status) {
                                                                        if (record.new) {
                                                                            if (record.update) {
                                                                                return (
                                                                                    <Space>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="primary"
                                                                                            onClick={() => this.onOKButton(index, "budgetAllocations", "updateBudgetAllocationData")}
                                                                                        >
                                                                                            {t("text_ok")}
                                                                                        </Button>
                                                                                        <Button
                                                                                            style={{marginTop: 0}}
                                                                                            type="danger"
                                                                                            onClick={() => this.onCancelButton(index, "budgetAllocations", "updateBudgetAllocationData", ["project", "percentage", "subProject","subProjectCode","payload"])}
                                                                                        >
                                                                                            {t("text_cancel")}
                                                                                        </Button>
                                                                                    </Space>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div style={{
                                                                                        fontSize: 23,
                                                                                        color: "red"
                                                                                    }}>
                                                                                        <CloseOutlined
                                                                                            onClick={() => this.onRemoveButtton(index, "budgetAllocations")}/>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                <div id="btn-action">
                                                                                    <div id="btnUpdate"
                                                                                         className="btn-update">
                                                                                        <Button
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            type="primary"
                                                                                            title={`${t("text_update")}`}
                                                                                            onClick={() => this.onUpdateButton(index, "budgetAllocations", "updateBudgetAllocationData")}
                                                                                            icon={<EditFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                        />
                                                                                    </div>

                                                                                    <div id="btnDelete"
                                                                                         className="btn-delete">

                                                                                        <Button
                                                                                            danger
                                                                                            title={t("text_delete")}
                                                                                            icon={<DeleteFilled
                                                                                                style={{color: "#fff"}}/>}
                                                                                            shape="circle"
                                                                                            type="primary"
                                                                                            style={{
                                                                                                marginTop: 0,
                                                                                                marginLeft: 5,
                                                                                                height: 35,
                                                                                                width: 35,
                                                                                                borderRadius: 35,
                                                                                                border: "none"
                                                                                            }}
                                                                                            onClick={() => this.onDeleteButtonBudgetAllocation(index)}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                },
                                                            },
                                                        ]}
                                                        pagination={false}
                                                        footer={() =>
                                                            <Button type="dashed" icon={<PlusOutlined/>}
                                                                    style={{width: "100%"}}
                                                                    onClick={() => this.onNewButton("budgetAllocations", ["project", "percentage", "subProject"])}>
                                                                {t("text_add_new")}
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    margin: 0
                                                }}>{t("text_contract_termination_notice_period")}</p>
                                                <Divider style={{margin: "6px 0px 25px 0px"}}/>
                                            </Col>
                                            <Col span={6}>
                                                <SelectInput
                                                    name="isNoticeTerminate"
                                                    label={t("text_notice_of_termination")}
                                                    errorMessage={"Please select yes/no!"}
                                                    onChange={this.onChangeNoticeTerminate}
                                                    valueKey="id"
                                                    allowClear={true}
                                                    placeholder={t("text_select_yes_no")}
                                                    dataSource={[
                                                        {id: 1, name: "Yes"},
                                                        {id: 0, name: "No"},
                                                    ]}
                                                />
                                            </Col>
                                            {
                                                this.props.form.getFieldValue("isNoticeTerminate") === 1 &&
                                                <Col lg={6} offset={2}>
                                                    <InputDate
                                                        name="noticeTerminateAt"
                                                        placeholder={t("text_dd_mm_yyyy")}
                                                        required={true}
                                                        style={{width: "100%"}}
                                                        format="DD/MM/YYYY"
                                                        label={t("text_notice_termination_at")}
                                                        errorMessage="Notice termination at is required"
                                                    />
                                                </Col>
                                            }
                                            <Col span={8} offset={2} id={"notice-period-type"}
                                                 style={{display: "none"}}>
                                                <Row>
                                                    <Col span={17}>
                                                        <SelectInput
                                                            name="noticePeriodType"
                                                            label={t("text_short_absent_notice_period")}
                                                            valueKey="id"
                                                            required={requiredNoticePeriodType}
                                                            errorMessage={"Please select notice period!"}
                                                            onChange={this.onChangeNoticePeriodType}
                                                            placeholder={t("text_select_notice_period")}
                                                            dataSource={[
                                                                {id: "2WEEK", name: "2 weeks"},
                                                                {id: "1MONTH", name: "1 month"},
                                                                {id: "2MONTH", name: "2 months"},
                                                                {id: "3MONTH", name: "3 months"},
                                                                {id: "CUSTOM", name: "Customize"},
                                                            ]}
                                                        />
                                                    </Col>
                                                    <Col span={6} offset={1} id="notice-period-type-working-day"
                                                         style={{display: "none"}}>
                                                        <NumberInput
                                                            label={"  "}
                                                            name={"noticePayload"}
                                                            placeholder={t("text_working_day")}
                                                            isAutoSelect={true}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={6} offset={!requiredNoticePeriodType && 2}>
                                                <SelectInput
                                                    name="terminationBenefit"
                                                    label={t("text_termination_benefit")}
                                                    valueKey="id"
                                                    allowClear={true}
                                                    placeholder={t("text_select_yes_no")}
                                                    dataSource={[
                                                        {id: 1, name: "Yes"},
                                                        {id: 0, name: "No"},
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </Card>

                                    <Card title={t("text_compensation_benefit")} bordered={false}
                                          className="employee-form" style={{marginBottom: 25}} id="profile-4">
                                        <Row gutter={25}>
                                            <Col lg={6}>
                                                <NumberInput
                                                    label={t("text_basic_salary")}
                                                    name="basicSalary"
                                                    placeholder={t("text_basic_salary")}
                                                    precision={2}
                                                />
                                            </Col>
                                            <Col lg={6} offset={2}>
                                                <InputDate
                                                    name="lastModifiedSalaryAt"
                                                    required={true}
                                                    placeholder={t("text_dd_mm_yyyy")}
                                                    style={{width: "100%"}}
                                                    format="DD/MM/YYYY"
                                                    label={t("text_effective_salary_date")}
                                                />
                                            </Col>
                                            <Col lg={7} offset={2}>
                                                <Row>
                                                    <Col span={14}>
                                                        <NumberInput
                                                            label={t("text_pension_fund")}
                                                            name="pensionFund"
                                                            placeholder={t("text_pension_fund")}
                                                            precision={2}
                                                        />
                                                    </Col>
                                                    <Col span={9} offset={1}>
                                                        <SelectInput
                                                            name="pensionFundType"
                                                            label={"  "}
                                                            allowClear={true}
                                                            placeholder={t("text_type")}
                                                            valueKey="id"
                                                            dataSource={[
                                                                {id: "AMOUNT", name: "Amount"},
                                                                {id: "PERCENTAGE", name: "Percentage"},
                                                            ]}
                                                        />

                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg={6}>
                                                <Row>
                                                    <Col span={14}>
                                                        <NumberInput
                                                            label={t("text_providend_fund")}
                                                            name="providentFund"
                                                            placeholder={t("text_providend_fund")}
                                                            precision={2}
                                                        />
                                                    </Col>
                                                    <Col span={9} offset={1}>
                                                        <SelectInput
                                                            name="providentFundType"
                                                            label={"  "}
                                                            valueKey="id"
                                                            allowClear={true}
                                                            placeholder={t("text_type")}
                                                            dataSource={[
                                                                {id: "AMOUNT", name: "Amount"},
                                                                {id: "PERCENTAGE", name: "Percentage"},
                                                            ]}
                                                        />

                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={6} offset={2}>
                                                <SelectInput
                                                    name="insurance"
                                                    label={t("text_insurance")}
                                                    valueKey="id"
                                                    mode="multiple"
                                                    placeholder={"Select insurance"}
                                                    dataSource={[
                                                        {id: "ACCIDENT", name: "Accident"},
                                                        {id: "HEALTH", name: "Health"},
                                                        {id: "LIFE", name: "Life"},
                                                    ]}
                                                />
                                            </Col>
                                            <Col span={7} offset={2}>
                                                <SelectInput
                                                    name="annualSalary"
                                                    label="13th Month Salary"
                                                    placeholder="Please select"
                                                    valueKey="id"
                                                    initialValue={1}
                                                    allowClear={true}
                                                    dataSource={[
                                                        {id: 1, name: "Yes"},
                                                        {id: 0, name: "No"},
                                                    ]}
                                                />
                                            </Col>
                                            <Col span={6}>
                                                <SelectInput
                                                    name="seniority_severancePay"
                                                    label={"Seniority/Severance Pay"}
                                                    valueKey="id"
                                                    placeholder={"Please select"}
                                                    allowClear={true}
                                                    dataSource={[
                                                        {id: "SENIORITY", name: "Seniority"},
                                                        {id: "SEVERANCEPAY", name: "Severance Pay"},
                                                    ]}
                                                />
                                            </Col>
                                             <Col lg={6} offset={2}>
                                                        <NumberInput
                                                                label="UnPaid Salary"
                                                                name="unpaidSalary"
                                                                placeholder={"unpaidSalary"}
                                                                defaultValue={0}
                                                                precision={2}
                                                            />
                                                    </Col>
                                                     <Col lg={7} offset={2}>
                                                        <NumberInput
                                                                label="Paid Seniority UDC"
                                                                name="paid_seniority_udc"
                                                                placeholder={"Paid Seniority UDC"}
                                                                defaultValue={0}
                                                                precision={2}
                                                        />
                                                    </Col>
                                            <Col lg={24}>
                                                <Table
                                                    rowKey={() => `benifits${Date.now() + Math.random()}`}
                                                    style={{marginTop: 15}}
                                                    dataSource={this.fixedEmployeeBenefits.concat(employeeBenefits)}
                                                    columns={[
                                                        {
                                                            title: t("text_benefit"),
                                                            dataIndex: "payrollItemId",
                                                            key: "payrollItemId",
                                                            render: (payrollItemId, record, index) => {
                                                                if (record.fix) {
                                                                    return record.title;
                                                                } else {
                                                                    return <SelectInput
                                                                        style={{marginBottom: 0}}
                                                                        defaultValue={payrollItemId}
                                                                        placeholder={t("text_select_benifit")}
                                                                        onChange={(_, option) => this.onChangeBenifit(option, index - 3, "code")}
                                                                        valueKey="payrollItemId"
                                                                        allowClear={true}
                                                                        required={true}
                                                                        dataSource={payrollItems}
                                                                    />
                                                                }
                                                            }
                                                        },
                                                        {
                                                            title: t("text_amount"),
                                                            dataIndex: "amount",
                                                            key: "amount",
                                                            render: (amount, record, index) => {
                                                                return <NumberInput
                                                                    style={{margin: 0}}
                                                                    placeholder={t("text_enter_amount")}
                                                                    onChange={record.fix ? (value) => this.onChangeBenifitFix(value, index, "amount") : (value) => this.onChangeBenifit(value, index - 3, "amount", record)}
                                                                    defaultValue={Math.abs(amount)}
                                                                    precision={2}
                                                                    isAutoSelect={true}
                                                                />
                                                            }
                                                        },
                                                        {
                                                            title: "Fringe Benefit Tax",
                                                            dataIndex: "isTaxable",
                                                            key: "isTaxable",
                                                            align: "center",
                                                            render: (isTaxable, record, index) => {
                                                                return <Checkbox
                                                                    defaultChecked={isTaxable}
                                                                    onChange={record.fix ? (event) => this.onChangeBenifitFix(event.target.checked, index, "isTaxable") : (event) => this.onChangeBenifit(event.target.checked, index - 3, "isTaxable")}
                                                                />
                                                            }
                                                        },
                                                        {
                                                            title: t("text_offered_tax_by"),
                                                            dataIndex: "offeredBy",
                                                            key: "offeredBy",
                                                            render: (offeredBy, record, index) => {
                                                                return <SelectInput
                                                                    style={{marginBottom: 0}}
                                                                    placeholder={t("text_select_benifit")}
                                                                    valueKey="id"
                                                                    required={true}
                                                                    allowClear={true}
                                                                    defaultValue={offeredBy ? offeredBy : "ORGANIZATION"}
                                                                    onChange={record.fix ? (value) => this.onChangeBenifitFix(value, index, "offeredBy") : (value) => this.onChangeBenifit(value, index - 3, "offeredBy")}
                                                                    dataSource={[
                                                                        {id: "ORGANIZATION", name: "Organization"},
                                                                        {id: "EMPLOYEE", name: "Employee"},
                                                                    ]}
                                                                />
                                                            }
                                                        },
                                                        {
                                                            title: t("text_action"),
                                                            dataIndex: "id",
                                                            key: "id",
                                                            width: 160,
                                                            align: "center",
                                                            render: (id, record, index) => {
                                                                if (!record.fix) {
                                                                    return (
                                                                        <div style={{
                                                                            fontSize: 23,
                                                                            color: "red"
                                                                        }}>
                                                                            <CloseOutlined
                                                                                onClick={() => this.onRemoveEmployeeBenifitButtton(index - 3, record)}/>
                                                                        </div>
                                                                    );
                                                                }
                                                            },
                                                        },
                                                    ]}
                                                    pagination={false}
                                                    footer={() =>
                                                        <Button type="dashed" icon={<PlusOutlined/>}
                                                                style={{width: "100%"}}
                                                                onClick={() => this.onNewButton("employeeBenefits", ["payrollItemId", "code", "amount", "isTaxable", "offeredBy", "type", "taxRate"])}>
                                                            {t("text_add_new")}
                                                        </Button>
                                                    }
                                                />
                                            </Col>
                                            <Col lg={24} style={{marginTop: 15}}>
                                                <p style={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    marginBottom: 15
                                                }}>{t("text_attachment_of_benefit_information")}</p>
                                            </Col>
                                            <Col lg={24}>
                                                <div id="employee-upload-file">
                                                    <Dragger
                                                        customRequest={(options) => this.onUploadFile(options, "benefitFiles", "upload_benefit", "benefits")}
                                                        multiple={true}
                                                        onRemove={(file) => this.onRemoveFile(file, "benefitFiles", "delete_benefit?path=benefits")}
                                                        fileList={benefitFiles}
                                                    >
                                                        <p className="ant-upload-drag-icon">
                                                            <PaperClipOutlined style={{fontSize: 35}}/>
                                                        </p>
                                                        <p className="ant-upload-text" style={{
                                                            fontSize: 16,
                                                            fontWeight: 400,
                                                            color: "#000000",
                                                            letterpacing: "-0.38px"
                                                        }}>Click or drag file to this area to upload</p>
                                                        <p className="ant-upload-hint">
                                                            Support for a single upload. Strictly prohibit from
                                                            uploading like insurance or other benefit files
                                                        </p>
                                                    </Dragger>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Form>
                                <Form
                                    form={this.props.formResetPassword}
                                    onFinish={this.onResetPasword}
                                    layout="vertical"
                                >
                                    <Card
                                        title={t("text_reset_password")}
                                        bordered={false}
                                        className="employee-form"
                                        style={{marginBottom: 25}}
                                    >
                                        <Row gutter={25}>
                                            <Col lg={8}>
                                                <Form.Item
                                                    name="password"
                                                    label={t("text_new_password")}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t("text_please_input_your_new_password"),
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password placeholder={t("text_please_enter_new_password")}/>
                                                </Form.Item>
                                            </Col>
                                            <Col lg={8} offset={2}>
                                                <Form.Item
                                                    name="confirm"
                                                    label={t("text_confirm_password")}
                                                    dependencies={["password"]}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t("text_please_input_your_confirm_password"),
                                                        },
                                                        ({getFieldValue}) => ({
                                                            validator(_, value) {
                                                                if (!value || getFieldValue("password") === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    new Error(t("text_your_confirm_password_does_not_match"))
                                                                );
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input.Password
                                                        placeholder={t("text_please_enter_new_password_again")}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col lg={6}>
                                                <Button htmlType="submit" type="danger" loading={loadingButton}
                                                        style={{marginTop: 30}}>{t("text_reset")}</Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Form>
                            </div>
                        </Spin>
                        :
                        <Result
                            status="403"
                            title="403"
                            subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
                        />
                }
            </>
        );
    }
}

const EmployeeUpdate = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const {id} = useParams();

    return <UpdateForm navigate={navigate} id={id} form={form}/>;
};
export default EmployeeUpdate;
